module.exports = __webpack_public_path__ + "static/media/healthcare_img.095d3934.png";